import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core'
import { DateComponent, DateFormat, DestroySubscribers } from '@ftr/foundation'
import { LocalDateTime, LocalTime } from '@js-joda/core'

export interface RealTimeSttSegmentMarkerInputs {
  numRemarks: number
  startTime?: LocalDateTime
}

interface ViewModel {
  speaker: number
  content: string
}

@Component({
  selector: 'ftr-real-time-stt-segment-marker',
  templateUrl: './real-time-stt-segment-marker.component.html',
  styleUrls: ['./real-time-stt-segment-marker.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, DateComponent],
})
export class RealTimeSttSegmentMarkerComponent
  extends DestroySubscribers
  implements OnChanges, RealTimeSttSegmentMarkerInputs
{
  @Input() numRemarks: number
  @Input() startTime?: LocalDateTime

  // Display a randomized transcript skeleton below a time marker when remark content is being loaded
  loadingRemarkPlaceholderWidths: ViewModel[]

  readonly dateFormats = DateFormat

  ngOnChanges(): void {
    const loadingRemarkPlaceholderLines = this.numRemarks
    this.loadingRemarkPlaceholderWidths = getPlaceholderModel(Math.max(1, loadingRemarkPlaceholderLines))
  }
}

function getPlaceholderModel(lines: number): ViewModel[] {
  return Array.from(Array(lines)).map(() => ({
    speaker: Math.floor(Math.random() * 2),
    content: `${Math.floor(Math.random() * LocalTime.SECONDS_PER_MINUTE) + 10}%`,
  }))
}
